import ClubSetupWizard from './ClubSetupWizard';

export default ClubSetupWizard;
